import axios from '../../axios'

// 新增公式分析
export const addFormula = (data) => {
    return axios({
        url: '/api/data/wish/formula/analysis',
        method: 'POST',
        data
    })
}

// 获取公式分析详情
export const getFormulaInfo = (data) => {
    return axios({
        url: '/api/data/wish/formula/analysis/info',
        method: 'GET',
        data
    })
}

// 修改公式分析信息
export const editFormula = (data) => {
    return axios({
        url: '/api/data/wish/formula/analysis',
        method: 'PUT',
        data
    })
}

// 删除公式分析信息
export const deleteFormula = (data) => {
    return axios({
        url: '/api/data/wish/formula/analysis',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索公式分析信息列表
export const searchFormulaList = (data) => {
    return axios({
        url: '/api/data/wish/formula/analysis',
        method: 'GET',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/formulaAnaly.js